import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "m-filter-menu",
  ref: "root"
}
const _hoisted_2 = { class: "c-wrapper c-wrapper--with-padding c-wrapper--with-padding--x" }
const _hoisted_3 = { class: "c-flex hidden@large" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "m-filter-menu__container" }
const _hoisted_6 = { class: "m-filter-menu__container__navigation hidden@large" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-label": "Close filters",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M15.0312 12.9688C15.6406 13.5312 15.6406 14.5156 15.0312 15.0781C14.75 15.3594 14.375 15.5 14 15.5C13.5781 15.5 13.2031 15.3594 12.9219 15.0781L8 10.1562L3.03125 15.0781C2.75 15.3594 2.375 15.5 2 15.5C1.57812 15.5 1.20312 15.3594 0.921875 15.0781C0.3125 14.5156 0.3125 13.5312 0.921875 12.9688L5.84375 8L0.921875 3.07812C0.3125 2.51562 0.3125 1.53125 0.921875 0.96875C1.48438 0.359375 2.46875 0.359375 3.03125 0.96875L8 5.89062L12.9219 0.96875C13.4844 0.359375 14.4688 0.359375 15.0312 0.96875C15.6406 1.53125 15.6406 2.51562 15.0312 3.07812L10.1094 8.04688L15.0312 12.9688Z" })
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "m-filter-menu__heading" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "c-wrapper c-wrapper--with-padding c-wrapper--with-padding--x" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TpxButton = _resolveComponent("TpxButton")!
  const _component_TpxFilterGroup = _resolveComponent("TpxFilterGroup")!
  const _component_TpxForm = _resolveComponent("TpxForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TpxButton, {
          class: "a-button a-button--primary m-filter-menu__button m-filter-menu__open",
          textColour: "blue",
          onClick: _ctx.open
        }, {
          default: _withCtx(() => [
            _createElementVNode("strong", null, [
              _createTextVNode(" Filter "),
              (_ctx.activeFilterCount > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString(_ctx.activeFilterCount) + ")", 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "a-button a-button--icon m-filter-menu__button m-filter-menu__button--icon",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, _hoisted_8),
        _createElementVNode("div", _hoisted_9, [
          _createTextVNode(" Filter "),
          (_ctx.activeFilterCount > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "(" + _toDisplayString(_ctx.activeFilterCount) + ")", 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          class: "a-button a-button--icon m-filter-menu__button m-filter-menu__button--basic",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
        }, "Clear")
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", {
          ref: "formBackdrop",
          class: "m-filter-menu__form__backdrop",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeAllTheFilterGroups && _ctx.closeAllTheFilterGroups(...args)))
        }, null, 512),
        _createVNode(_component_TpxForm, {
          class: "m-filter-menu__form",
          includeNavigation: false,
          method: "get"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterGroupsData, (filterGroup) => {
              return (_openBlock(), _createBlock(_component_TpxFilterGroup, _mergeProps({
                ref_for: true,
                ref: "filtergroup",
                key: filterGroup.label
              }, filterGroup, {
                checkboxes: filterGroup.checkboxes,
                "onUpdate:checkboxes": ($event: any) => ((filterGroup.checkboxes) = $event),
                onChange: _ctx.onChange
              }), null, 16, ["checkboxes", "onUpdate:checkboxes", "onChange"]))
            }), 128))
          ]),
          _: 1
        }),
        (_ctx.activeFilterCount)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "a-button a-button--icon m-filter-menu__button m-filter-menu__button--basic m-filter-menu__button--clear",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
            }, "Clear"))
          : _createCommentVNode("", true)
      ])
    ])
  ], 512))
}